{
  "Welcome, please create your account": "Welcome! Create your account",
  "External login": "Login",
  "Email": "Email",
  "Password": "Password",
  "Password does not match": "Password does not match",
  "Invalid Email Address": "Invalid email address",
  "Password needs a minimum of: ": "Password needs a minimum of: ",
  "8 characters": "8 characters",
  "1 uppercase character": "1 uppercase character",
  "1 lowercase character": "1 lowercase character",
  "1 number": "1 number",
  "Verification email sent": "Verification email sent",
  "verify-account": "You need to verify your account to login. Follow the instructions sent to your email when you created your account.",
  "no-email-resend": "Didn't receive an email? Click to resend.",
  "Login": "Login",
  "Create account": "Create account",
  "Internal login": "Log in with SSO",
  "use-sso": "Use Single Sign-On (SSO) to log in automatically.",
  "Reset password": "Reset password",
  "Reset": "Reset",
  "Resend": "Resend",
  "Cancel": "Cancel",
  "A message has been sent to": "A message has been sent to",
  "Repeat password": "Repeat password",
  "Your password was updated successfully": "Your password was updated.",
  "Go to login": "Log in",
  "Set password": "Set password",
  "First name": "First name",
  "Last name": "Last name",
  "Confirm password": "Confirm password",
  "Your account was created successfully.": "Your account was created.",
  "confirmation-email": "A confirmation email has been sent.",
  "Go to login page": "Go to login ",
  "Sign up": "Create",
  "Make sure that you are using your company email address.": "Make sure that you are using your company email address.",
  "password-requirements": "The password must contain at least 8 characters, one uppercase and lowercase character and a number.",
  "The provided token is not valid": "The provided token is not valid",
  "Unknown error. Please try again or contact customer support": "Unknown error. Try again or contact support.",
  "token-expired": "Your verification token has expired. Click the button below to send a new one",
  "Resend verification": "Resend ",
  "Go to start page": "Get started!",
  "Your account has been verified": "Your account has been verified.",
  "Success": "Success!",
  "A new verification email has been sent to you": "A new verification email has been sent.",
  "Enter your email to reset": "Enter your email to reset",
  "password-reset-email-message": "Click on the link in the email to set a new password. If you don't see it, wait 5 minutes and don't forget to check your spam folder.",
  "canvas-error": "There was an error during canvas authentication"
}
